export const regexes = {
  numbersAndDot: {
    reg: /^$|^\d*\.?\d*$/,
    errorMsg: "Only numbers and dot allowed",
  },
  numbersAndTwoDecimalsAfterDot: {
    reg: /^[0-9]*(\.[0-9]{0,2})?$/,
    errorMsg: "Only numbers and to Decimals are allowed",
  },
  wholeNumbers: {
    reg: /^[1-9][0-9]*$/,
    errorMsg: "Only whole numbers are allowed",
  },
  everyNumber: {
    reg: /^[0-9][0-9]*$/,
    errorMsg: "Only whole numbers are allowed",
  },
  numbersDotComma: {
    reg: /^[0-9]*[,.]?[0-9]*$/,
    errorMsg: "Only numbers dot or comma are allowed",
  },
  onlyZeroes: {
    reg: /^[0]+$/,
    errorMsg: "zero is not allowed",
  },
};
